export const USER_DETAILS_TAB_GROUPS = [
  { label: 'Profile', tabs: ['user-details', 'user-agency', 'account-history'] },
  { label: 'Sales', tabs: ['quotes', 'custom-offers'] },
  {
    label: 'Loyalty',
    tabs: [
      'loyalty-programs-memberships',
      'luxplus-member-profile',
      'luxloyalty-member-profile',
      'velocity-memberships',
    ],
  },
  { label: 'Activity', tabs: ['recent-searches', 'recent-offer-page-views', 'abandoned-carts', 'carts'] },
  { label: 'Account checks', tabs: ['security', 'similar-accounts', 'atol-certificates'] },
] as const;

export type UserDetailsTabKey = (typeof USER_DETAILS_TAB_GROUPS)[number]['tabs'][number];

export type UserDetailsTabs = Record<UserDetailsTabKey, { label: string; showTab: boolean }>;

export function isUserDetailsTabKey(value: string | null | undefined): value is UserDetailsTabKey {
  return USER_DETAILS_TAB_GROUPS.some((group) => group.tabs.some((tab) => tab === value));
}
